/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/no-danger */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as accountActions from '../../actions/accountActions';
import MetaTags from 'react-meta-tags';
import urls from '../../constants/urls.js';
import PageLoading from '../common/PageLoading';
import * as qs from 'query-string';
import * as browserCheck from '../../utils/browserCheck.js';
import {genders} from '../../constants/staticLists';
import ToastrService from '../../services/toastrService';
import LocationService from '../../services/locationService';
import { checkPasswordStrength } from '../../utils/textUtils';
import swal from 'sweetalert';
import SweetAlertTextInput from '../common/SweetAlertTextInput';
import isEmail from 'validator/lib/isEmail';
import isEmpty from 'validator/lib/isEmpty';
import AsyncTypeahead from 'react-bootstrap-typeahead/lib/AsyncTypeahead.react'; 
import PasswordStrengthInput from '../common/PasswordStrengthInput';
import moment from 'moment';
import * as urlUtils from '../../utils/urlUtils';
import ErrorMessage from '../common/ErrorMessage';
import MaterialInput from '../common/MaterialInput';
import MaterialDropDown from '../common/MaterialDropDown';

class SignupPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.signup = this.signup.bind(this);
        this.externalSignup = this.externalSignup.bind(this);
        this.onChange = this.onChange.bind(this);
        this.checkForExternalSignupCallback = this.checkForExternalSignupCallback.bind(this);
        this.getExternalLogins = this.getExternalLogins.bind(this);
        this.registerExternalAccount = this.registerExternalAccount.bind(this);
        this.getNext = this.getNext.bind(this);
        this.locationSearch = this.locationSearch.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.locationBlur = this.locationBlur.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
        const loading = this.checkForExternalSignupCallback();
        this.state = 
        { 
            email: '',
            password: '',           
            firstName: '',
            lastName: '',
            gender: '',
            dateOfBirth: null,
            location: null,         
            username: '',   
            externalLogins: [],
            loading: loading,
            locationTypeaheadLoading: false,
            locationTypeaheadOptions: [],
            locationFocused: false
        };         
    }

    componentWillMount() {
        if(!this.state.loading) {
            this.getExternalLogins();
        }
    }

    componentDidMount() {  
        if (browserCheck.canUseDom()) {
            window.componentHandler.upgradeDom(); 
            
            //we need this for the date picker
            //https://github.com/T00rk/bootstrap-material-datetimepicker
            window.moment = moment;
            const bootstrapMaterialDatePicker = require('bootstrap-material-datetimepicker/js/bootstrap-material-datetimepicker.js');
            $(this.dateOfBirthControl).bootstrapMaterialDatePicker({ 
                time: false,
                maxDate: moment().subtract(13, 'years')
            }).on('change', (e, date) => {
                e.preventDefault();
                e.stopPropagation();
                this.setState({dateOfBirth: date});
            });
        }    
    }

    getNext() {
         //check the querystring for a returnUrl
         if(this.props.location.search) {
            const params = qs.parse(this.props.location.search);
            if(params && params.returnUrl && !urlUtils.isExternalUrl(params.returnUrl, this.props.location)) {
                if(urlUtils.isSoundCloudRedirect(this.props.location)) {
                    return `${params.returnUrl}${this.props.location.hash}`;
                }
                else {
                    //if using a social login, it's possible they already had an account and logged in instead of signing up so check for active profiles
                    if(this.props.user.activeProfile) {
                        return params.returnUrl;
                    }
                    else {
                        if(params.returnUrl !== '/Profile/Create') {
                            return `/Profile/Create?returnUrl=${params.returnUrl}`;
                        }
                        else {
                            return '/Profile/Create';
                        }
                    }
                }
            }
        }
        else if(this.props.location.state && this.props.location.state.from && this.props.location.state.from.pathname) {
            return `/Profile/Create?returnUrl=${this.props.location.state.from.pathname}`;
        }
        else {
            return this.props.user && this.props.user.activeProfile ? '/Welcome' : '/Profile/Create';
        }
    }

    externalSignup(event, provider) {
        event.preventDefault();
        let login;
        if(this.state.externalLogins.length) {
            login = this.state.externalLogins.find(l => l.Name === provider);
        }
        if(login) {
            const apiUrl = urls.API_URL;
            window.location = `${login.Url}`;
        }        
    }

    getExternalLogins() {
        if(!this.state.externalLogins.length) {
            //add a trailing slash after the url as otherwise, Safari will strip the oauth fragment added to the url after the #
            let pathname = window.location.pathname;
            if(pathname[pathname.length - 1] !== '/') {
                pathname = pathname + '/';
            }
            this.props.actions.getExternalLoginsList(pathname)
                .then(logins => {
                    if(!this.props.user) {
                        //we've already redirected if the user is set
                        this.setState({
                            externalLogins: logins
                        });
                    }
                })
                .catch(error => {
                });
        }
    }

    registerExternalAccount(email) {
        const toastrService = new ToastrService();
        this.props.actions.registerExternal(email)
            .then(data => {
                if(!data) {
                    toastrService.showError('Social signup failed', 'Sorry, something went wrong');
                    this.getExternalLogins();
                }
            })
            .catch(err => {
                toastrService.showError('Social signup failed', 'Sorry, something went wrong');
                this.getExternalLogins();
            });
    }

    signup(event) {
        event.preventDefault();
        if(this.formIsValid()) {
            const location = this.state.location[0];
            const city = location.city;
            const region = location.region;
            const country = location.country;
            const longitude = location.longitude;
            const latitude = location.latitude;
            this.props.actions.signup(this.state.email, 
                this.state.password, 
                this.state.firstName, 
                this.state.lastName, 
                this.state.dateOfBirth.format('YYYY-MM-DD'), 
                this.state.gender, 
                city,
                region,
                country,
                longitude,
                latitude
            );
        }
    }

    formIsValid() {
        const strength = checkPasswordStrength(this.state.password);
        if(isEmpty(this.state.email)) {
            this.props.actions.setSignupError('Looks like you forgot to enter your e-mail address');
            return false;
        }
        else if(!strength.pass) {
            this.props.actions.setSignupError('The password is too weak. Try including at least 2 of uppercase and lowercase letters, numbers, and symbols');
            return false;
        }
        else if(isEmpty(this.state.firstName)) {
            this.props.actions.setSignupError('Looks like you forgot to enter your first name');
            return false;
        }
        else if(isEmpty(this.state.lastName)) {
            this.props.actions.setSignupError('Looks like you forgot to enter your last name');
            return false;
        }
        else if(!this.state.dateOfBirth) {
            this.props.actions.setSignupError('Looks like you forgot to enter your date of birth');
            return false;
        }
        else if(!(this.state.location && this.state.location.length)) {
            this.props.actions.setSignupError('Looks like you forgot to enter your location (city name)');
            return false;
        }
        else if(moment().subtract(13, 'years') < this.state.dateOfBirth) {
            this.props.actions.setSignupError('Sorry, you need to be at least 13 years old to create an account');
            return false;
        }
        else if(this.state.username) {
            this.props.actions.setSignupError('Sorry, something went wrong! Please contact us to investigate.');
            return false;            
        }
        return true;
    }

    checkForExternalSignupCallback() {
        let loading = false;
        const toastrService = new ToastrService();
        //if (browserCheck.canUseDom()) {            
        const hash = this.props.location.hash;
        let params = {};
        if(hash) {
            params = qs.parse(hash.substr(1));
        }
        let accessTokenCookie = browserCheck.canUseDom? document.cookie
            .split('; ')
            .find(row => row.startsWith('AccessToken')) : null;
        let accessToken = accessTokenCookie ? accessTokenCookie.split('=')[1] : (params.access_token ? params.access_token : null);
        let expiresAtCookie = browserCheck.canUseDom() ? document.cookie
            .split('; ')
            .find(row => row.startsWith('ExpiresAt')) : null;
        let expires = expiresAtCookie ? decodeURIComponent(expiresAtCookie.split('=')[1]) : (params.expires_at ? params.expires_at : null);
        if(accessToken) {
            loading = true;
            //delete the token details from the cookie now we've read it (it's set to expire in 5 mins but let's be extra safe)
            const domain = window.location.hostname;
            document.cookie = `AccessToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
            document.cookie = `Expires=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 UTC;Domain=${domain}`;
            //this will just save the token. it will set the newSignup flag to false, but we set it to true in the registerExternalAccount action - that's when we know for sure
            this.props.actions.loginSuccess(accessToken);
            this.props.actions.getUserInfo()
                .then(userInfo => {
                    if(userInfo) {
                        if(userInfo.HasRegistered) {
                            this.props.actions.getUser(true);
                        }
                        else {
                            if(userInfo.Email) {
                                this.registerExternalAccount(userInfo.Email);
                            }
                            else {
                                const wrapper = document.createElement('div');
                                ReactDOM.render(<SweetAlertTextInput type="email" label="Email address" />, wrapper);
                                const el = wrapper.firstChild;
                                swal('Please enter your email address', {
                                    content: el,
                                    buttons: [true, true]
                                })
                                .then(email => {
                                    if(email) {
                                        if(isEmail(email)) {
                                            this.registerExternalAccount(email);
                                        }
                                        else {
                                            toastrService.showError('Social signup failed', 'The email address entered doesn\'t look quite right');
                                            this.getExternalLogins();
                                        }
                                    }
                                    else {
                                        toastrService.showError('Social signup failed', 'We need your email address to complete the sign up');
                                        this.getExternalLogins();
                                    }
                                });
                            }
                                
                            this.setState({
                                loading: false
                            });
                        }
                    }
                    else {
                        toastrService.showError('Social signup failed', 'Sorry, it looks like your signup attempt may have timed out, please try again');
                        this.setState({
                            loading: false
                        });
                        this.getExternalLogins();
                    }
                })
                .catch(error => {
                    this.setState({
                        loading: false
                    });
                });
        }
        else if(params.error) {
            toastrService.showError('Social signup failed', 'Sorry, something went wrong, unable to complete signup');
        }
        return loading;
    }

    onChange(event) {
        const field = event.target.name;
        let value = event.target.value;
        let newState = Object.assign({}, this.state);
		newState[field] = value;
		return this.setState(newState);
    }

    locationSearch(query) {
        this.setState({locationTypeaheadLoading: true});
        LocationService.searchLocation('', false, true, query)
            .then(items => {
                this.setState({
                    locationTypeaheadLoading: false,
                    locationTypeaheadOptions: items
                });
            } );
    }

    locationSelected(location) {
        this.setState({location});        
    }

    locationBlur(event) {
        this.setState({locationFocused: false});
        const location = this.state.location;
        if(!location || !location.length) {
            this.typeaheadRef._instance.getInstance().setState({text: ''});
        }
    }

    render() {
        return (
            this.props.user ?
                <Redirect to={this.getNext()} />
                :
                !this.state.loading && !this.props.userLoading ?
                    <div className="main">
                        <MetaTags>
                            <title>Signup - LoudUp</title>
                            <meta id="description" name="description" content="Create a LoudUp account to start getting connected." />
                            <meta id="robots" name="robots" content="noindex" />
                        </MetaTags> 
                        <style dangerouslySetInnerHTML={{__html: `
                            .username { display:none; }
                            .tt-input.loading { background-size: contain; }
                            `}} />
                        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
                        <div className="container">
                            <div className="block-inner">
                                <div className="signupbox">
                                    <h1 className="section-alt">Sign up for a free account</h1>
                                    <br />
                                    <p className="smalltype">By signing up, you are confirming that you have read and agree to the <Link to="/Terms">terms of use</Link>, <Link to="/Privacy">privacy policy</Link>, and <Link to="/CookiePolicy">cookie usage policy</Link></p>
                                    <br />
                                    <div className="signbody">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <h3>SIGN UP WITH YOUR SOCIAL ACCOUNT</h3>
                                                <div className="socsignup">
                                                    <div className="soclogin text-center">
                                                        <a href={null} style={{cursor: "pointer"}} onClick={(e) => this.externalSignup(e, 'Facebook')}>
                                                            <img src={require('../../images/btn-socialsign-fb.png')} width="290" height="41" alt="Sign up with Facebook" />
                                                        </a>
                                                        <br />
                                                        <br />
                                                        <a href={null} style={{cursor: "pointer"}} onClick={(e) => this.externalSignup(e, 'Twitter')}>
                                                            <img src={require('../../images/btn-socialsign-tw.png')} width="290" height="41" alt="Sign up with Twitter" />
                                                        </a>
                                                    </div>
                                                    <br />
                                                    <p className="grey text-center"><span className="arrow-right" />Quicker sign-up</p>
                                                    <p className="grey text-center"><span className="arrow-right" />One less password to remember!</p>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <h3>SIGN UP FOR A LOUDUP ACCOUNT</h3>
                                                <div className="form form-signup form-tightfields">
                                                    <form id="frmSignup" onSubmit={this.signup}>
                                                        <ErrorMessage error={this.props.signupError} onClose={this.props.actions.clearSignupError} />
                                                        <div className="form form-signup form-tightfields">
                                                            <MaterialInput name="email" label="E-mail address" type="email" value={this.state.email} onChange={this.onChange} />
                                                            <div id="divPassword" className="mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block form-mpassstrength">
                                                                <PasswordStrengthInput id="password" name="password" onChange={this.onChange} value={this.state.password} /> 
                                                                <label className="mdl-textfield__label" htmlFor="password">Password</label>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <MaterialInput name="firstName" label="First Name" value={this.state.firstName} onChange={this.onChange} />
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <MaterialInput name="lastName" label="Last Name" value={this.state.lastName} onChange={this.onChange} />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                    <MaterialDropDown 
                                                                        name="gender"
                                                                        label="Gender"
                                                                        value={this.state.gender}
                                                                        className={`mdl-block select-distance placeholder ${this.state.gender ? 'is-dirty' : ''}`}
                                                                        data={genders}
                                                                        onClick={(e) => this.onChange({target: {name: 'gender', value: e.target.innerText}})} />
                                                                </div>
                                                                <div id="divDOB" className="col-md-6">
                                                                    <MaterialInput name="dateOfBirth" label="Date of birth" className={this.state.dateOfBirth ? 'is-dirty' : ''} value={this.state.dateOfBirth ? this.state.dateOfBirth.format('DD MMM YYYY') : ''} readOnly inputRef={(control) => this.dateOfBirthControl = control} />
                                                                </div>
                                                            </div>
                                                            <div id="divLocation" className={`mdl-textfield mdl-js-textfield mdl-textfield--floating-label mdl-block ${this.state.locationFocused ? 'is-focused' : ''} ${this.state.location && this.state.location.length ? 'is-dirty' : ''}`}>
                                                                <AsyncTypeahead id="location" minLength={3} isLoading={this.state.locationTypeaheadLoading} onSearch={this.locationSearch} onChange={this.locationSelected} options={this.state.locationTypeaheadOptions} selected={this.state.location} onFocus={() => this.setState({locationFocused: true})} onBlur={this.locationBlur} required ref={(component) => this.typeaheadRef = component} />
                                                                <label className="mdl-textfield__label" htmlFor="location">Location (City Name)</label>
                                                            </div>
                                                            <div id="divUsername" className="form-group username">
                                                                <input id="username" name="username" className="inputfield form-control" value={this.state.username} placeholder="Username" onChange={this.onChange} />                                                                    
                                                            </div>

                                                            <div className="form-group">
                                                                <input id="button" className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent btn-block" type="submit" value="SIGN UP" name="button" />
                                                            </div>
                                                            <p className="text-center smalltype">
                                                                Already have an account? <Link to="/Account/Login">Log in here »</Link>
                                                            </p>                                                             
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                :
                    <div>
                        <PageLoading />
                    </div>
        );
    }
}

SignupPage.propTypes = {
    user: PropTypes.object,
    signupError: PropTypes.string,
    actions: PropTypes.object.isRequired,
    location: PropTypes.object,
    userLoading: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return { 
        user: state.account.user,
        userLoading: state.account.userLoading,
        signupError: state.account.signupError
    };
}

function mapDispatchToProps(dispatch) {
    return {
        //account actions will now be available under this.props.actions
        actions: bindActionCreators(Object.assign({}, accountActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignupPage);